module.exports = __webpack_public_path__ + "static/media/grin-tongue.1d8ea0ba.svg";